import http from "../support/http";

export default {
  async fetchByCardUuid(cardUuid) {
    return (await http().get(`/api/v1/integration/accounts/${cardUuid}`)).data;
  },
};
